// extracted by mini-css-extract-plugin
export default {"container":"USV10_container__YsiAj","joystick":"USV10_joystick__8DqZY","inactive":"USV10_inactive__WUE5Z","info":"USV10_info__4v-CD","item":"USV10_item__jgIi+"};